import type { FC } from "react"

import { studioToScreen } from "@logic/lib/design"
import { useRecoilValue } from "recoil"

import { selectionBoxState } from "../../../state/elements/transactions/findCenterOfSelectedPanels"
import { zoomState } from "../../../state/view"

const PanelSelectionOutline: FC = () => {
  const selectionBox = useRecoilValue(selectionBoxState)
  const zoom = useRecoilValue(zoomState)
  const rectangle = studioToScreen.rectangle(selectionBox.box, zoom)
  const center = studioToScreen.point(selectionBox.center, zoom)

  return (
    <>
      <circle cx={center.x} cy={center.y} r={5} fill="red" />
      <rect
        fill="none"
        stroke="red"
        strokeWidth={1}
        x={rectangle.x}
        y={rectangle.y}
        width={rectangle.w}
        height={rectangle.h}
        transform={`rotate(${rectangle.r})`}
      />
    </>
  )
}

export default PanelSelectionOutline
